





























































































































































































































































































































import { FormModalParams, FormModalSizeEnum } from '@/components/global/modal/form-modal-models';
import OtFormModal from '@/components/global/modal/ot-form-modal.vue';
import OtAutocomplete, { IAutocompleteItem } from '@/components/global/ot-autocomplete.vue';
import OtButton, { OtBtnSize, OtBtnStyle, OtBtnType } from '@/components/global/ot-button.vue';
import OtComboBox from '@/components/global/ot-combo-box.vue';
import OtDatePicker from '@/components/global/ot-date-picker.vue';
import OtDateTimeField from '@/components/global/ot-date-time-field.vue';
import OtExpansionPanel from '@/components/global/ot-expansion-panel.vue';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import OtRadioGroup, { IRadioGroupOption } from '@/components/global/ot-radio-group.vue';
import OtSelect from '@/components/global/ot-select.vue';
import OtTag from '@/components/global/ot-tag.vue';
import OtTextField from '@/components/global/ot-text-field.vue';
import OtTextarea from '@/components/global/ot-textarea.vue';
import OtTableHeader from '@/components/global/table/ot-table-header.vue';
import { IExtendedColumnData } from '@/components/global/table/ot-table-models';
import OtTable from '@/components/global/table/ot-table.vue';
import OtApi, { executeApi } from '@/services/api.service';
import {
  DocumentReceivalType as ApiDocumentReceivalType,
  GetDocumentResponseDocumentVersionModel as ApiGetDocumentResponseDocumentVersionModel,
  GetDocumentResponseModel as ApiGetDocumentResponseModel,
  AconexMailMetadataModel as ApiAconexMailMetadataModel,
  AconexDocumentMetadataModel as ApiAconexDocumentMetadataModel,
  PostCreateDocumentFromAconexRequestModel as ApiPostCreateDocumentFromAconexRequestModel,
  PostCreateDocumentRequestModel as ApiPostCreateDocumentRequestModel,
  PostUpdateDocumentRequestModel as ApiPostUpdateDocumentRequestModel,
} from '@/services/generated/api';
import Styles from '@/styles/variables.scss';
import {
  documentReceivalTypes,
  OtDocumentReceivalType,
  parsedApiDocumentReceivalType,
  parsedOtDocumentReceivalType,
} from '@/types/document-receival-type';
import { ZonelessDate } from '@/types/zoneless-date';
import { formatDate, formatDateAndTime, getBrowserTimezone } from '@/utils/date-utils';
import { blurCombos, IVForm } from '@/utils/type-utils';
import { getTimeZones } from '@vvo/tzdb';
import { isFuture } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { v4 as uuidv4 } from 'uuid';
import { Component, Ref, Vue } from 'vue-property-decorator';
import OtCreateDocumentAssociations from '../create-document-associations/ot-create-document-associations.vue';
import { DocumentListItem } from '../document-list/document-list-models';
import {
  AddEditDialogMode,
  AddEditDocumentDialogParams,
  AddEditDocumentDialogResult,
} from './add-edit-document-dialog-models';
import downloadjs from 'downloadjs';

interface IDocumentDialogFileListItem {
  key: string;
  gidFile: string | null;
  dateCreated: Date | null;
  fileName: string;
  fileFormat: string;
  isUploading: boolean;
  isDownloading: boolean;
  willBeRemoved: boolean;
  isNew: boolean;
  progress: number;
  error: string | null;
  // TODO why do we not have file size here?
}
class DocumentDialogFileListItem implements IDocumentDialogFileListItem {
  public key = '';
  public gidFile: string | null = null;
  public fileName = '';
  public fileFormat = '';
  public dateCreated: Date | null = null;
  public isUploading = false;
  public isDownloading = false;
  public willBeRemoved = false;
  public isNew = false;
  public progress = 0;
  public error: string | null = null;
  constructor(vals: IDocumentDialogFileListItem) {
    Object.assign(this, vals);
  }
  public setProgressFromEvent(e: ProgressEvent) {
    if (!e.lengthComputable) {
      this.progress = 0;
      return;
    }
    if (e.loaded >= e.total) {
      this.progress = 1;
      return;
    }

    this.progress = e.loaded / e.total;
  }
  public get canRemove() {
    return !this.willBeRemoved;
  }
  public get canUndoRemove() {
    return this.willBeRemoved;
  }
  public get canDownload() {
    // can't download a new file, the server rejects it, it's not attached to anything yet so the server doesn't know if you are allowed to see it or not
    // the server could probably be persuaded to check if the current user created the file, but not yet
    return !this.isNew && !!this.gidFile;
  }
  public get hasMenuItems() {
    return this.canRemove || this.canUndoRemove;
  }
  public remove() {
    this.willBeRemoved = true;
  }
  public undoRemove() {
    this.willBeRemoved = false;
  }
}

function getLatestVersion(model: ApiGetDocumentResponseModel) {
  const versionsSortedByCreatedDateDesc = [...model.versions].sort(
    (a, b) => b.createdDateUtc.getTime() - a.createdDateUtc.getTime(),
  );
  return versionsSortedByCreatedDateDesc[0];
}

interface IAddEditDocumentFormObject {
  name: string;
  reference: string;
  contentDescription: string | null;
  description: string | null;
  receivalType: OtDocumentReceivalType | null;
  receivalDescription: string | null;
  documentDate: ZonelessDate | null;
  /** This should be the local timezone: 6pm in received timezone is represented as 6pm local timezone on screen */
  documentReceivedLocalBrowser: Date | null;
  /** This should be the local timezone: 6pm in received timezone is represented as 6pm local timezone on screen */
  documentDeemedReceivedLocalBrowser: Date | null;
  receivedTimeZone: string | null;
  deemedReceivedTimeZone: string | null;
  senderPerson: string | null;
  senderOrganisation: string | null;
  recipientPerson: string | null;
  recipientOrganisation: string | null;
}

class AddEditDocumentFormObject implements IAddEditDocumentFormObject {
  public name!: string;
  public reference!: string;
  public contentDescription: string | null = null;
  public description: string | null = null;
  public receivalType: OtDocumentReceivalType | null = null;
  public receivalDescription: string | null = null;
  public documentDate: ZonelessDate | null = null;
  public documentReceivedLocalBrowser: Date | null = null;
  public documentDeemedReceivedLocalBrowser: Date | null = null;
  public receivedTimeZone: string | null = null;
  public deemedReceivedTimeZone: string | null = null;
  public senderPerson: string | null = null;
  public senderOrganisation: string | null = null;
  public recipientPerson: string | null = null;
  public recipientOrganisation: string | null = null;

  public constructor(value: IAddEditDocumentFormObject) {
    Object.assign(this, value);
  }

  public static createEmpty(): AddEditDocumentFormObject {
    // return a basic empty model
    return new AddEditDocumentFormObject({
      name: '',
      reference: '',
      contentDescription: null,
      description: null,
      receivalType: OtDocumentReceivalType.Email,
      receivalDescription: null,
      documentDate: null,
      documentReceivedLocalBrowser: null,
      documentDeemedReceivedLocalBrowser: null,
      receivedTimeZone: null,
      deemedReceivedTimeZone: null,
      senderPerson: null,
      senderOrganisation: null,
      recipientPerson: null,
      recipientOrganisation: null,
    });
  }

  public static fromApi(latestVersion: ApiGetDocumentResponseDocumentVersionModel): AddEditDocumentFormObject {
    // EXTREME SPAFFERY AHEAD. Dealing with just dates is a mess.
    // What comes over the wire is "2025-01-01"
    // Which the generated code just basically does new Date("2025-01-01") with
    // According to MDN, is a bit dumb.
    //   When the time zone offset is absent, date-only forms are interpreted as a UTC time
    //   and date-time forms are interpreted as a local time. The interpretation as a UTC time is due to a
    //   historical spec error that was not consistent with ISO 8601 but could not be changed due to web compatibility.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format
    // The finished date that pops out has been treated as UTC, and then the browser helpully "converts" it to local for us everywhere we use it
    // So we end up with something that is "7am on the 25th" if you're in a +7 timezone
    // or, "5pm on the 24th" if you're in a -7 timezone
    // We can't change the generated code (probably could, but heckin effort)
    // We don't want to send "2021-01-01T00:00:00.000" over the wire because that's ugly (it'd probably fix this issue, but I'm not sure, and it's a big change)
    // So we'll "unscrew" the date here
    // I could probably use one of the helper libraries to do this, but effort. Instead, this idea worked in f12 tools, so it'll do
    // Take the date, turn it back into the UTC string with the timezone in it.
    // which turns something like "2025-01-01" into "2025-01-01T00:00:00.000Z" (remembering that we have a date object)
    // then get rid of the Z so we have a string that is absent of timezone information
    // then new up a date using THAT string, which will treat it as local. Not UTC.
    // One Day we should look at putting this into a helper. Or into ZonelessDate itself. I suspect it's a common issue we just haven't looked closely enough at
    // Like, for instance, the Claim Models has a Due Date that is a Zoneless Date. I wonder if it has "7am" in it client side. I wonder if people in the - zones would be seeing the day before on screen.
    const correctedDate = latestVersion.date ? new Date(latestVersion.date.toISOString().replace('Z', '')) : null;
    return new AddEditDocumentFormObject({
      name: latestVersion.name,
      reference: latestVersion.reference,
      contentDescription: latestVersion.contentDescription ?? null,
      description: latestVersion.description ?? null,
      receivalType: latestVersion.receivalType ? parsedOtDocumentReceivalType[latestVersion.receivalType] : null,
      receivalDescription: latestVersion.receivalDescription ?? null,
      documentDate: correctedDate ? new ZonelessDate(correctedDate) : null,
      // server to client - convert these.
      // See https://github.com/marnusw/date-fns-tz#time-zone-offset-helpers for a worked example of why we are doing this conversion
      documentReceivedLocalBrowser:
        latestVersion.receivedUtc && latestVersion.receivedTimeZone
          ? utcToZonedTime(latestVersion.receivedUtc, latestVersion.receivedTimeZone)
          : null,
      // server to client - convert these.
      // See https://github.com/marnusw/date-fns-tz#time-zone-offset-helpers for a worked example of why we are doing this conversion
      documentDeemedReceivedLocalBrowser:
        latestVersion.deemedReceivedUtc && latestVersion.deemedReceivedTimeZone
          ? utcToZonedTime(latestVersion.deemedReceivedUtc, latestVersion.deemedReceivedTimeZone)
          : null,
      receivedTimeZone: latestVersion.receivedTimeZone ?? null,
      deemedReceivedTimeZone: latestVersion.deemedReceivedTimeZone ?? null,
      senderPerson: latestVersion.senderPerson ?? null,
      senderOrganisation: latestVersion.senderOrganisation ?? null,
      recipientPerson: latestVersion.recipientPerson ?? null,
      recipientOrganisation: latestVersion.recipientOrganisation ?? null,
    });
  }

  public static fromAconexDocument(aconexDocument: ApiAconexDocumentMetadataModel): AddEditDocumentFormObject {
    return new AddEditDocumentFormObject({
      name: aconexDocument.title ?? '',
      reference: aconexDocument.documentNumber ?? '',
      contentDescription: aconexDocument.documentType ?? null,
      description: aconexDocument.comments ?? null,
      receivalType: parsedOtDocumentReceivalType[ApiDocumentReceivalType.Aconex],
      receivalDescription: null,
      documentDate: null,
      documentReceivedLocalBrowser: null,
      documentDeemedReceivedLocalBrowser: null,
      receivedTimeZone: null,
      deemedReceivedTimeZone: null,
      senderPerson: null,
      senderOrganisation: null,
      recipientPerson: null,
      recipientOrganisation: null,
    });
  }
  public static fromAconexMail(aconexMail: ApiAconexMailMetadataModel): AddEditDocumentFormObject {
    // There could be more than one recipient
    // But, we only have one spot in our database
    // So, we'll find the first TO user and use that
    // If we don't find one, we'll use the first user
    // This could be a problem if everyone is BCC'd, but we'll cross that bridge when we get to it
    const recipientUser =
      aconexMail.toUsers.find(x => 'TO'.localeCompare(x.distributionType, undefined, { sensitivity: 'base' }) === 0) ??
      aconexMail.toUsers[0];

    return new AddEditDocumentFormObject({
      name: aconexMail.subject ?? '',
      reference: aconexMail.mailNo ?? '',
      contentDescription: aconexMail.correspondenceType ?? null,
      description: null,
      receivalType: parsedOtDocumentReceivalType[ApiDocumentReceivalType.Aconex],
      receivalDescription: null,
      documentDate: null,
      documentReceivedLocalBrowser: null,
      documentDeemedReceivedLocalBrowser: null,
      receivedTimeZone: null,
      deemedReceivedTimeZone: null,
      senderPerson: aconexMail.fromUserDetails?.name ?? null,
      senderOrganisation: aconexMail.fromUserDetails?.organizationName ?? null,
      recipientPerson: recipientUser.name ?? null,
      recipientOrganisation: recipientUser.organizationName ?? null,
    });
  }

  public toPostCreateDocument(): ApiPostCreateDocumentRequestModel {
    return new ApiPostCreateDocumentRequestModel({
      name: this.name,
      reference: this.reference,
      contentDescription: this.contentDescription ?? undefined,
      description: this.description ?? undefined,
      receivalType: this.receivalType ? parsedApiDocumentReceivalType[this.receivalType.value] : undefined,
      receivalDescription: this.receivalDescription ?? undefined,
      // Neat. Date is a Date in the model, then in the toJson method they turn it into the iso format. Based on somethingsomething in the openapi spec
      date: this.documentDate ?? undefined, // this.date ? this.date.toZonelessDateFormat() : undefined,
      // client to server - convert these from local timezone to contract timezone using https://github.com/marnusw/date-fns-tz#zonedtimetoutc
      // See https://github.com/marnusw/date-fns-tz#time-zone-offset-helpers for a worked example of why we are doing this conversion
      receivedUtc:
        this.documentReceivedLocalBrowser && this.receivedTimeZone
          ? zonedTimeToUtc(this.documentReceivedLocalBrowser, this.receivedTimeZone)
          : undefined,
      deemedReceivedUtc:
        this.documentDeemedReceivedLocalBrowser && this.deemedReceivedTimeZone
          ? zonedTimeToUtc(this.documentDeemedReceivedLocalBrowser, this.deemedReceivedTimeZone)
          : undefined,
      receivedTimeZone:
        this.documentReceivedLocalBrowser && this.receivedTimeZone
          ? this.receivedTimeZone /* get on the next line dang it - stupid linter */
          : undefined,
      deemedReceivedTimeZone:
        this.documentDeemedReceivedLocalBrowser && this.deemedReceivedTimeZone
          ? this.deemedReceivedTimeZone /* get on the next line dang it - stupid linter */
          : undefined,
      senderPerson: this.senderPerson ?? undefined,
      senderOrganisation: this.senderOrganisation ?? undefined,
      recipientPerson: this.recipientPerson ?? undefined,
      recipientOrganisation: this.recipientOrganisation ?? undefined,
      // associations and files are not part of this edit model, default them here, they will be set externally
      organisationAssociations: [],
      projectAssociations: [],
      contractAssociations: [],
      filesToAdd: [],
    });
  }

  public toPostCreateFromAconex(): ApiPostCreateDocumentFromAconexRequestModel {
    return new ApiPostCreateDocumentFromAconexRequestModel({
      name: this.name,
      reference: this.reference,
      contentDescription: this.contentDescription ?? undefined,
      description: this.description ?? undefined,
      // Neat. Date is a Date in the model, then in the toJson method they turn it into the iso format. Based on somethingsomething in the openapi spec
      date: this.documentDate ?? undefined, // this.date ? this.date.toZonelessDateFormat() : undefined,
      // client to server - convert these from local timezone to contract timezone using https://github.com/marnusw/date-fns-tz#zonedtimetoutc
      // See https://github.com/marnusw/date-fns-tz#time-zone-offset-helpers for a worked example of why we are doing this conversion
      receivedUtc:
        this.documentReceivedLocalBrowser && this.receivedTimeZone
          ? zonedTimeToUtc(this.documentReceivedLocalBrowser, this.receivedTimeZone)
          : undefined,
      deemedReceivedUtc:
        this.documentDeemedReceivedLocalBrowser && this.deemedReceivedTimeZone
          ? zonedTimeToUtc(this.documentDeemedReceivedLocalBrowser, this.deemedReceivedTimeZone)
          : undefined,
      receivedTimeZone:
        this.documentReceivedLocalBrowser && this.receivedTimeZone
          ? this.receivedTimeZone /* get on the next line dang it - stupid linter */
          : undefined,
      deemedReceivedTimeZone:
        this.documentDeemedReceivedLocalBrowser && this.deemedReceivedTimeZone
          ? this.deemedReceivedTimeZone /* get on the next line dang it - stupid linter */
          : undefined,
      senderPerson: this.senderPerson ?? undefined,
      senderOrganisation: this.senderOrganisation ?? undefined,
      recipientPerson: this.recipientPerson ?? undefined,
      recipientOrganisation: this.recipientOrganisation ?? undefined,
      // associations and files are not part of this edit model, default them here, they will be set externally
      organisationAssociations: [],
      projectAssociations: [],
      contractAssociations: [],
    });
  }
  public toPostUpdateDocument(): ApiPostUpdateDocumentRequestModel {
    return new ApiPostUpdateDocumentRequestModel({
      name: this.name,
      reference: this.reference,
      contentDescription: this.contentDescription ?? undefined,
      description: this.description ?? undefined,
      receivalType: this.receivalType ? parsedApiDocumentReceivalType[this.receivalType.value] : undefined,
      receivalDescription: this.receivalDescription ?? undefined,
      date: this.documentDate ?? undefined,
      // client to server - convert these from local timezone to contract timezone using https://github.com/marnusw/date-fns-tz#zonedtimetoutc
      // See https://github.com/marnusw/date-fns-tz#time-zone-offset-helpers for a worked example of why we are doing this conversion
      receivedUtc:
        this.documentReceivedLocalBrowser && this.receivedTimeZone
          ? zonedTimeToUtc(this.documentReceivedLocalBrowser, this.receivedTimeZone)
          : undefined,
      deemedReceivedUtc:
        this.documentDeemedReceivedLocalBrowser && this.deemedReceivedTimeZone
          ? zonedTimeToUtc(this.documentDeemedReceivedLocalBrowser, this.deemedReceivedTimeZone)
          : undefined,
      receivedTimeZone:
        this.documentReceivedLocalBrowser && this.receivedTimeZone
          ? this.receivedTimeZone /* get on the next line dang it - stupid linter */
          : undefined,
      deemedReceivedTimeZone:
        this.documentDeemedReceivedLocalBrowser && this.deemedReceivedTimeZone
          ? this.deemedReceivedTimeZone /* get on the next line dang it - stupid linter */
          : undefined,
      senderPerson: this.senderPerson ?? undefined,
      senderOrganisation: this.senderOrganisation ?? undefined,
      recipientPerson: this.recipientPerson ?? undefined,
      recipientOrganisation: this.recipientOrganisation ?? undefined,
      filesToAdd: [],
      filesToRemove: [],
    });
  }
}

const ACONEX_NEWER_VERSION_IMPORT_YES: IRadioGroupOption = {
  key: 'yes',
  label: 'Yes, import the latest version from Aconex',
};
const ACONEX_NEWER_VERSION_IMPORT_NO: IRadioGroupOption = {
  key: 'no',
  label: 'No, do not import the latest version from Aconex',
};

@Component({
  components: {
    OtFormModal,
    OtButton,
    OtTextField,
    OtTextarea,
    OtSelect,
    OtAutocomplete,
    OtDatePicker,
    OtComboBox,
    OtRadioGroup,
    OtTable,
    OtTableHeader,
    OtTag,
    OtLoadingSpinner,
    OtDateTimeField,
    OtCreateDocumentAssociations,
    OtExpansionPanel,
  },
})
export default class OtAddEditDocumentDialog extends Vue {
  // * PROPS
  private api = new OtApi();
  private buttonSize = OtBtnSize.Tiny;
  private buttonStyle = OtBtnStyle.Outline;
  private buttonType = OtBtnType.Icon;

  // * REFS
  @Ref('formModalRef') private readonly formModalRef!: OtFormModal;
  @Ref('modalContentRef') private readonly modalContentRef!: IVForm;
  @Ref('createDocumentAssociationsRef') private readonly createDocumentAssociationsRef?: OtCreateDocumentAssociations;

  // * DATA
  private fileTableColumns: IExtendedColumnData<DocumentDialogFileListItem>[] = [
    {
      index: 0,
      label: 'Name',
      key: 'name',
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 1,
      label: 'Date uploaded',
      key: 'date',
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 2,
      label: '',
      key: 'actions',
      isActive: false,
      ascending: false,
      sortable: false,
    },
  ];
  private fileItems: DocumentDialogFileListItem[] = [];
  private get filesToDisplay() {
    // if they add one, then remove it, don't care, don't display it
    // the rest we want to display - new ones and removed ones might be visualised differently?
    // return this.fileItems.filter(x => !(x.isNew && x.willBeRemoved));
    // actually, the above was fine thinking, but I've changed my mind. If they add one and remove it and go "DAMN WRONG FILE", let 'em add it again eh?
    return this.fileItems;
  }

  private formData = AddEditDocumentFormObject.createEmpty();
  /** This is for existing documents that have already been imported from Aconex. If we're creating a new document, use the ones on the params */
  private aconexDocumentMetadata: ApiAconexDocumentMetadataModel | null = null;
  /** This is for the latest version of an existing document that has been imported from Aconex. There is no equivalent when creating, it can be used to show the "there's a new version" check */
  private latestAconexDocumentMetadata: ApiAconexDocumentMetadataModel | null = null;

  /** This is for existing documents that have already been imported from Aconex. If we're creating a new document, use the ones on the params */
  private aconexMailMetadata: ApiAconexMailMetadataModel | null = null;

  private contentDescriptions: string[] = [];

  private get otBlue300() {
    return Styles.otColorBlue300;
  }
  private allTimezones = getTimeZones()
    .filter(t => t.countryCode === 'AU')
    .flatMap(t => t.group)
    .sort((a, b) => a.localeCompare(b));
  private get allTimezoneItems(): IAutocompleteItem<string>[] {
    const timezoneNames: IAutocompleteItem<string>[] = this.allTimezones.map(t => {
      return { label: t, data: t };
    });
    return timezoneNames;
  }
  private get selectedReceivedTimeZone() {
    if (this.formData.receivedTimeZone) {
      return this.allTimezoneItems.find(x => x.data === this.formData.receivedTimeZone) ?? null;
    }
    return null;
  }
  private set selectedReceivedTimeZone(val: IAutocompleteItem<string> | null) {
    if (val?.data) {
      this.formData.receivedTimeZone = val.data;
    } else {
      this.formData.receivedTimeZone = null;
    }
  }
  private get selectedDeemedReceivedTimeZone() {
    if (this.formData.deemedReceivedTimeZone) {
      return this.allTimezoneItems.find(x => x.data === this.formData.deemedReceivedTimeZone) ?? null;
    }
    return null;
  }
  private set selectedDeemedReceivedTimeZone(val: IAutocompleteItem<string> | null) {
    if (val?.data) {
      this.formData.deemedReceivedTimeZone = val.data;
    } else {
      this.formData.deemedReceivedTimeZone = null;
    }
  }

  private get documentReceivalTypeOptions(): IRadioGroupOption[] {
    return documentReceivalTypes.map(t => {
      return {
        label: t.name,
        key: t.value,
      };
    });
  }

  private get selectedReceivalType() {
    if (this.formData.receivalType) {
      return this.documentReceivalTypeOptions.find(t => t.key === this.formData.receivalType?.value) ?? null;
    }
    return null;
  }
  private set selectedReceivalType(val: IRadioGroupOption | null) {
    if (val !== null) {
      this.formData.receivalType = documentReceivalTypes.find(t => t.value === val.key) ?? null;
    } else {
      this.formData.receivalType = null;
    }

    // Description is only valid if they pick Other
    if (this.formData.receivalType?.value !== OtDocumentReceivalType.Other.value) {
      this.formData.receivalDescription = null;
    }
  }
  private get isReceivalDescriptionDisabled() {
    return this.formData.receivalType !== OtDocumentReceivalType.Other;
  }

  private get aconexMail() {
    if (this.isEitherCreate) {
      return this.params?.aconexMail;
    } else {
      return this.aconexMailMetadata;
    }
  }
  private get hasAconexMail() {
    return Boolean(this.aconexMail);
  }
  private get aconexDocument() {
    // it'll be on the stuff that comes from the server
    if (this.isEitherCreate) {
      return this.params?.aconexDocument;
    } else {
      return this.aconexDocumentMetadata;
    }
  }
  private get hasAconexDocument() {
    return Boolean(this.aconexDocument);
  }

  private get isReceivalTypeDisabled() {
    return this.hasAconexDocument;
  }

  private get hasNoAconexData() {
    return !this.hasAconexMail && !this.hasAconexDocument;
  }

  private get canEditFiles() {
    return this.hasNoAconexData;
  }

  private get documentDateErrorMessages() {
    if (this.formData.documentDate && isFuture(this.formData.documentDate)) {
      return 'Cannot be in the future';
    }
    return undefined;
  }

  private get documentRecievedErrorMessages() {
    if (this.formData.documentReceivedLocalBrowser && isFuture(this.formData.documentReceivedLocalBrowser)) {
      return 'Cannot be in the future';
    }

    // We could consider time zones here?
    // BUT, document date doesn't have a time zone though
    // So we have no reference point
    // It is entirely possible that the document was drafted in a different timezone to where it was received
    // It is possible that it was, say, put together on the 11 Nov in NZ, emailed to Los Angeles, received on the 10th in LA time.
    // So, we'll just compare The Date to The Date And Time and move on
    if (
      this.formData.documentDate &&
      this.formData.documentReceivedLocalBrowser &&
      !(this.formData.documentReceivedLocalBrowser >= this.formData.documentDate)
    ) {
      console.log('documentRecievedErrorMessages', {
        documentDate: this.formData.documentDate,
        received: this.formData.documentReceivedLocalBrowser,
      });
      return 'Must be >= Document Date';
    }
    return undefined;
  }

  private get documentDeemedRecievedErrorMessages() {
    if (
      this.formData.documentDeemedReceivedLocalBrowser &&
      isFuture(this.formData.documentDeemedReceivedLocalBrowser)
    ) {
      return 'Cannot be in the future';
    }

    if (
      this.formData.documentDate &&
      this.formData.documentDeemedReceivedLocalBrowser &&
      !(this.formData.documentDeemedReceivedLocalBrowser >= this.formData.documentDate)
    ) {
      return 'Must be >= Document Date';
    }
    return undefined;
  }

  private get isCreate() {
    return this.params?.mode === AddEditDialogMode.Create;
  }
  private get isCreateForWorkflow() {
    return this.params?.mode === AddEditDialogMode.CreateForWorkflow;
  }
  private get isEitherCreate() {
    return this.isCreate || this.isCreateForWorkflow;
  }
  private get isEdit() {
    return this.params?.mode === AddEditDialogMode.Edit;
  }
  private get hasNewerAconexDocumentVersion() {
    return (
      this.isEdit &&
      this.aconexDocumentMetadata?.versionNumber !== undefined &&
      this.latestAconexDocumentMetadata?.versionNumber !== undefined &&
      this.aconexDocumentMetadata.versionNumber < this.latestAconexDocumentMetadata.versionNumber
    );
  }
  private aconexNewerVersionOptions = [ACONEX_NEWER_VERSION_IMPORT_YES, ACONEX_NEWER_VERSION_IMPORT_NO];
  private selectedAconexNewerVersionOption: IRadioGroupOption | null = null;

  // * METHODS

  private onFileInputChange(files: File[]) {
    this.addFilesToList(files);
  }
  private onDropFile(e: DragEvent) {
    if (e.dataTransfer?.files) {
      const files = Array.from(e.dataTransfer.files);
      this.addFilesToList(files);
    }
  }

  private addFilesToList(files: File[]) {
    console.log('adding files to list');
    const newItems = files.map(file => ({
      file,
      item: new DocumentDialogFileListItem({
        key: uuidv4(),
        fileName: file.name,
        fileFormat: file.type,
        isNew: true,
        isUploading: false,
        isDownloading: false,
        willBeRemoved: false,
        progress: 0,
        gidFile: null,
        dateCreated: null,
        error: null,
      }),
    }));

    this.fileItems = this.fileItems.concat(newItems.map(x => x.item));
    for (const f of newItems) {
      this.uploadFile(f.file, f.item);
    }
  }
  private async uploadFile(file: File, item: DocumentDialogFileListItem) {
    if (file.size === 0) {
      item.error = 'File is empty';
      return;
    }
    if (file.size > 300_000_000) {
      item.error = 'File is too large - maximum file size is 300MB';
      return;
    }

    const onUploadProgress = (ev: ProgressEvent) => {
      console.log('upload progress for key "' + item.key + '"', ev);
      item.setProgressFromEvent(ev);
    };

    item.isUploading = true;
    item.progress = 0;
    const uploadResult = await executeApi(
      () =>
        this.api.filesWithProgress().postUploadFile({ data: file, fileName: file.name }, undefined, onUploadProgress),
      'up',
    );
    item.isUploading = false;
    if (uploadResult.success && uploadResult.data) {
      item.gidFile = uploadResult.data.gid;
    }
  }

  private async downloadFile(file: DocumentDialogFileListItem) {
    const gidFile = file.gidFile;
    if (!gidFile) {
      console.warn('ot-add-edit-document-dialog-> downloadFile - no gidFile, bailing', file);
      return;
    }
    const onDownloadProgress = (ev: ProgressEvent) => {
      console.log('download progress for key "' + gidFile + '"', ev);
      file.setProgressFromEvent(ev);
    };
    file.isDownloading = true;
    file.progress = 0;
    const apiResult = await executeApi(
      () => this.api.filesWithProgress().getFile(gidFile, undefined, onDownloadProgress),
      'Downloading File',
    );
    file.isDownloading = false;
    if (apiResult.success && apiResult.data) {
      const contentType =
        (apiResult.data.headers && apiResult.data.headers['content-type']) || 'application/octet-stream';
      const fileName = apiResult.data.fileName || file.fileName || 'download';

      downloadjs(apiResult.data.data, fileName, contentType);
    }
  }

  private async loadContentDescriptions() {
    const results = await executeApi(
      () => this.api.documents().getDocumentContentDescriptionList(),
      'Load Document Content List',
    );
    if (results.data) {
      this.contentDescriptions = results.data;
    }
  }

  public async validate() {
    blurCombos(this.$refs.documentContentCombo);

    // wait for a re-render so we absotively posilutely have the values where they should be
    await this.$nextTick();

    let isValid = true;

    if (this.createDocumentAssociationsRef) {
      isValid = isValid && (await this.createDocumentAssociationsRef.validate());
    }

    return isValid;
  }

  private isLoading = false;
  private params: AddEditDocumentDialogParams | null = null;

  private async initialise(params: AddEditDocumentDialogParams) {
    this.isLoading = true;

    // remember these for other spots we need them
    this.params = params;
    // dunno why. Just feels like we should wait
    await this.$nextTick();

    await this.loadContentDescriptions();

    //if (this.createDocumentAssociationsRef) {
    // for some reason, we never hit this. The component hasn't actually been mounted yet
    // which makes it hard to reset it. The component resets in its mounted lifecycle callback, so that'll do
    // I'm leaving this here because it's the Right Thing to do, but it doesn't work
    // await this.createDocumentAssociationsRef.reset();
    //}

    this.fileItems = [];
    this.aconexDocumentMetadata = null;
    this.aconexMailMetadata = null;
    this.latestAconexDocumentMetadata = null;

    const gid = this.params?.documentGid;
    if (this.isEdit && gid) {
      const document = await executeApi(() => this.api.documents().getDocument(gid), 'Load Document');
      if (document.data) {
        const latestVersion = getLatestVersion(document.data);
        this.formData = AddEditDocumentFormObject.fromApi(latestVersion);

        this.aconexDocumentMetadata = latestVersion.aconexDocumentMetadata ?? null;
        this.aconexMailMetadata = latestVersion.aconexMailMetadata ?? null;

        if (Boolean(latestVersion.aconexDocumentVersions?.length) && latestVersion.aconexDocumentMetadata) {
          const sortedAconexVersions = [...(latestVersion.aconexDocumentVersions ?? [])]
            // in theory the numeric version can be empty. Not seen it in practice, but here we are
            .filter(x => x.versionNumber !== null && x.versionNumber !== undefined)
            // the ?? is to shut the compiler up, we know there'll be a version number, we filtered for that already
            .sort((a, b) => (b.versionNumber ?? -1) - (a.versionNumber ?? -1));

          const thisVersionNumber = latestVersion.aconexDocumentMetadata?.versionNumber ?? -1;
          const latestVersionNumber = sortedAconexVersions[0].versionNumber ?? -1;

          if (latestVersionNumber > thisVersionNumber) {
            this.latestAconexDocumentMetadata = sortedAconexVersions[0];
          }
        }

        this.fileItems = latestVersion.files.map(
          x =>
            new DocumentDialogFileListItem({
              key: x.gid,
              fileName: x.name,
              fileFormat: x.format,
              isNew: false,
              isUploading: false,
              isDownloading: false,
              willBeRemoved: false,
              progress: 0,
              gidFile: x.gid,
              dateCreated: x.createdDateUtc,
              error: null,
            }),
        );
      }
    } else if (this.isEitherCreate) {
      // we're creating - reset back to blank, with some sensible defaults
      this.resetFormData();
    } else {
      // uh?
      console.warn('ot-add-edit-document-dialog -> initialise -> unknown mode', this.params?.mode);
    }

    this.isLoading = false;
  }

  private resetFormData() {
    if (this.params?.aconexDocument) {
      this.formData = AddEditDocumentFormObject.fromAconexDocument(this.params.aconexDocument);
      // add the document as a file item too
      if (this.params.aconexDocument.fileSize) {
        this.fileItems.push(
          new DocumentDialogFileListItem({
            key: this.params.aconexDocument.documentId ?? 'this is the key for the file that is the document',
            fileName: this.params.aconexDocument.filename ?? '',
            fileFormat: this.params.aconexDocument.fileType ?? '',
            isNew: false,
            isUploading: false,
            isDownloading: false,
            willBeRemoved: false,
            progress: 0,
            gidFile: null,
            dateCreated: this.params.aconexDocument.revisionDateUtc ?? null, // not sure about the date. I think this works?
            error: null,
          }),
        );
      }
    } else if (this.params?.aconexMail) {
      this.formData = AddEditDocumentFormObject.fromAconexMail(this.params.aconexMail);
      const localFileAttachments =
        this.params?.aconexMail?.attachments?.localFileAttachments?.map(
          x =>
            new DocumentDialogFileListItem({
              key: x.attachmentId,
              fileName: x.fileName,
              fileFormat: '',
              isNew: false,
              isUploading: false,
              isDownloading: false,
              willBeRemoved: false,
              progress: 0,
              gidFile: null,
              dateCreated: null,
              error: null,
            }),
        ) ?? [];
      const registeredDocumentAttachments =
        this.params?.aconexMail?.attachments?.registeredDocumentAttachments?.map(
          x =>
            new DocumentDialogFileListItem({
              key: x.attachmentId,
              fileName: x.fileName,
              fileFormat: '',
              isNew: false,
              isUploading: false,
              isDownloading: false,
              willBeRemoved: false,
              progress: 0,
              gidFile: null,
              dateCreated: x.revisionDateUtc ?? null,
              error: null,
            }),
        ) ?? [];
      this.fileItems = localFileAttachments.concat(registeredDocumentAttachments);
    } else {
      this.formData = AddEditDocumentFormObject.createEmpty();
    }

    // and set some defaults
    const tzString = getBrowserTimezone();
    this.formData.deemedReceivedTimeZone = tzString;
    this.formData.receivedTimeZone = tzString;
  }

  public async open(params: AddEditDocumentDialogParams): Promise<AddEditDocumentDialogResult> {
    if (!params.validate()) {
      console.error('ot-add-edit-document-dialog -> open -> invalid params, bailing', params);
      return new AddEditDocumentDialogResult({});
    }

    let title = '';
    let confirmText = '';
    if (params.mode === AddEditDialogMode.Edit) {
      title = 'Edit Document';
      confirmText = 'Edit Document';
    } else {
      title = 'Create New Document for ' + params.context;
      confirmText = 'Create Document & Add It To ' + params.context;
    }

    let createdDocumentGid: string | null = null;
    let createdDocumentVersionGid: string | null = null;

    const baseParams = new FormModalParams({
      title,
      formRef: this.modalContentRef,
      confirmText,
      cancelText: 'Cancel',
      size: FormModalSizeEnum.Max,
      onValidate: this.validate,
      onAfterFormMounted: () => this.initialise(params),
      onBeforeConfirmClose: async () => {
        // Post some data to somewhere
        if (this.isCreate || this.isCreateForWorkflow) {
          if (this.hasAconexDocument || this.hasAconexMail) {
            const createResult = await this.doCreateFromAconex();
            createdDocumentGid = createResult.documentGid ?? null;
            createdDocumentVersionGid = createResult.documentVersionGid ?? null;
            return createResult.ok;
          } else {
            const createResult = await this.doCreate();
            createdDocumentGid = createResult.documentGid ?? null;
            createdDocumentVersionGid = createResult.documentVersionGid ?? null;
            return createResult.ok;
          }
        } else if (this.isEdit) {
          const editResult = await this.doEdit();
          createdDocumentVersionGid = editResult.createdDocumentVersionGid ?? null;
          return editResult.ok;
        }
        return true;
      },
    });
    const result = await this.formModalRef.open(baseParams);
    if (result.ok) {
      return new AddEditDocumentDialogResult({
        ok: true,
        createdDocumentGid,
        createdDocumentVersionGid,
        // HACK: not sure this is a good idea or not - we need to get the document details on screen to the caller, specifically when creating a document for a workflow
        // The api could return an object model that has what we need in it, that'd be a bit better
        // This WILL NOT work if we ever need the version number, that has to come from the api
        // We could just pass the whole formData object, but this is better than tying to a model specifically designed for editing
        // The consumer could make a call to getDocument directly after getting the document result back, but meh, this is easier
        document: new DocumentListItem({
          gid: createdDocumentGid ?? params.documentGid ?? '', // if we made one, use that gid. Otherwise, we are editing, we dang well better have an incoming gid, the final ?? is to shut the compiler up
          documentVersionGid: createdDocumentVersionGid ?? '', // this'll be filled in, but we need to shut the compiler up
          reference: this.formData.reference,
          name: this.formData.name,
          contentDescription: this.formData.contentDescription,
          date: this.formData.documentDate,
          organisationAssociations: [],
          projectAssociations: [],
          contractAssociations: [],
          segmentInstanceAssociations: [],
          availableActions: [],
          isSelected: false,
          receivalType: this.formData.receivalType,
          receivalDescription: this.formData.receivalDescription,
          deemedReceivedUtc: this.formData.documentDeemedReceivedLocalBrowser,
          deemedReceivedTimeZone: this.formData.deemedReceivedTimeZone,
          aconexDocumentMetadata: null, // this.aconexDocument ?? null, // These are for the search results metadata, not the big metadata. We only have the big metadata handy, we don't have the search results metadata here
          aconexMailMetadata: null, //this.aconexMail ?? null,          // Which means that nobody consuming the results will know we have created from aconex or not. I think this'll be OK
          versionIndex: 1,
          isOutdatedVersion: false,
          isOrpaned: false, // I don't know if we are orphaned or not. If we're edit, we might have been. If we're create, we might be. The caller won't care, so we'll pretend like we are not orphaned
        }),
      });
    }
    return new AddEditDocumentDialogResult({ ok: false });
  }

  private async doCreate() {
    const requestModel = this.formData.toPostCreateDocument();
    const associations = this.createDocumentAssociationsRef ? await this.createDocumentAssociationsRef.submit() : null;
    if (associations) {
      if (associations.addToOrganisation && this.params?.targetOrganisationGid) {
        requestModel.organisationAssociations = [this.params.targetOrganisationGid];
      }
      requestModel.projectAssociations = associations.addToProjectGids;
      requestModel.contractAssociations = associations.addToContractGids;
    }
    // the as string[] is needed because this version of typescript doesn't understand that the filter for truthy on gidFile means we won't have any null gidFiles in there
    requestModel.filesToAdd = this.fileItems
      .filter(x => x.isNew && !x.willBeRemoved && Boolean(x.gidFile))
      .map(x => x.gidFile) as string[];
    const apiResponse = await executeApi(
      () => this.api.documents().postCreateDocument(requestModel),
      'Create Document',
    );
    if (apiResponse && apiResponse.success) {
      return {
        ok: true,
        documentGid: apiResponse.data?.documentGid,
        documentVersionGid: apiResponse.data?.documentVersionGid,
      };
    }
    return { ok: false };
  }

  private async doCreateFromAconex() {
    const requestModel = this.formData.toPostCreateFromAconex();
    if (this.params?.aconexDocument) {
      requestModel.documentId = this.params.aconexDocument.documentId;
    } else if (this.params?.aconexMail) {
      requestModel.mailId = this.params.aconexMail.mailId;
    } else {
      console.error(
        'ot-add-edit-document-dialog -> doCreateFromAconex -> aconexDocument and aconexMail are falsy, bailing',
      );
      return { ok: false };
    }
    const aconexProjectId = this.params?.aconexProjectId;
    if (!aconexProjectId) {
      console.error('ot-add-edit-document-dialog -> doCreateFromAconex -> aconexProjectId is null, bailing');
      return { ok: false };
    }

    const associations = this.createDocumentAssociationsRef ? await this.createDocumentAssociationsRef.submit() : null;
    if (associations) {
      if (associations.addToOrganisation && this.params?.targetOrganisationGid) {
        requestModel.organisationAssociations = [this.params.targetOrganisationGid];
      }
      requestModel.projectAssociations = associations.addToProjectGids;
      requestModel.contractAssociations = associations.addToContractGids;
    }
    const apiResponse = await executeApi(
      () => this.api.aconex().postCreateDocumentFromAconex(aconexProjectId, requestModel),
      'Create Document From Aconex',
    );
    if (apiResponse && apiResponse.success) {
      return {
        ok: true,
        documentGid: apiResponse.data?.result?.documentGid,
        documentVersionGid: apiResponse.data?.result?.documentVersionGid,
      };
    }
    return { ok: false };
  }
  private async doEdit() {
    const requestModel = this.formData.toPostUpdateDocument();
    // the as string[] is needed because this version of typescript doesn't understand that the filter for truthy on gidFile means we won't have any null gidFiles in there
    requestModel.filesToAdd = this.fileItems
      .filter(x => x.isNew && !x.willBeRemoved && Boolean(x.gidFile))
      .map(x => x.gidFile) as string[];
    requestModel.filesToRemove = this.fileItems
      .filter(x => x.willBeRemoved && Boolean(x.gidFile))
      .map(x => x.gidFile) as string[];
    if (
      this.hasNewerAconexDocumentVersion &&
      this.selectedAconexNewerVersionOption?.key === ACONEX_NEWER_VERSION_IMPORT_YES.key
    ) {
      requestModel.updateToLatestAconexDocumentVersion = true;
    }
    const apiResponse = await executeApi(
      () => this.api.documents().postUpdateDocument(this.params?.documentGid ?? '', requestModel),
      'Update Document',
    );
    if (apiResponse && apiResponse.success) {
      return {
        ok: true,
        createdDocumentVersionGid: apiResponse.data?.documentVersionGid,
      };
    }
    return { ok: false };
  }

  private formatDate(date: Date | null) {
    if (date) {
      return formatDate(date);
    }
    return '';
  }
  private formatDateAndTime(date: Date | null) {
    if (date) {
      return formatDateAndTime(date);
    }
    return '';
  }
}
